import { PHONE_FORMATTING_CHARS } from '@/shared/constants/claims'

export function normalizePhone(value: string): string {
  return value.replace(PHONE_FORMATTING_CHARS, '')
}
